import { render, staticRenderFns } from "./BrickAndSubstructurePrintPage3.vue?vue&type=template&id=56d7b711"
import script from "./BrickAndSubstructurePrintPage3.vue?vue&type=script&lang=js"
export * from "./BrickAndSubstructurePrintPage3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports